import React from 'react';

interface IProps {
  prop: string;
  errors: object;
}

const Errors: React.FC<IProps> = ({ errors, prop }) => {
  return (
    <div key={errors + prop}>
      {errors[prop] && (
        <label htmlFor={errors[prop]} className={'text-small'} style={{ color: 'red' }}>
          {errors[prop][0]}
        </label>
      )}
    </div>
  );
};

export default Errors;
